/** Stable IDs for tools published by the platform-owned MCP source. */
export const PLATFORM_TOOL_IDS = [
    'attach', 'card.create', 'card.link_change', 'card.move', 'card.remove_label',
    'card.set_label', 'checklist.report', 'discussion', 'epic.feedback',
    'epic.prototype', 'epic.question', 'epic.question.update', 'epic.update',
    'finish', 'memory.get', 'memory.search', 'proposal.create', 'quorum',
    'read_card', 'run.cancel', 'run.list', 'release.create_operation', 'release.list_targets',
    'release.report_attempt', 'release.resolve_plan', 'release.start_attempt',
    'release.status', 'release.prepare_plan', 'report', 'search_cards',
];
const descriptor = (id, capability, group) => ({ id, capability, group });
/** One canonical registry drives discovery, validation and the Console. */
export const PLATFORM_TOOL_CATALOG = [
    descriptor('report', null, 'work'), descriptor('finish', null, 'work'),
    descriptor('checklist.report', null, 'work'), descriptor('attach', 'board.evidence.append', 'work'),
    descriptor('read_card', 'task.read', 'board'), descriptor('discussion', 'thread.read', 'board'),
    descriptor('search_cards', 'task.read', 'board'), descriptor('card.create', 'task.triage', 'board'),
    descriptor('card.move', 'board.transition.request', 'board'),
    descriptor('card.set_label', 'board.label.mutate', 'board'),
    descriptor('card.remove_label', 'board.label.mutate', 'board'),
    descriptor('card.link_change', 'board.link.change', 'board'),
    descriptor('memory.search', 'task.read', 'memory'), descriptor('memory.get', 'task.read', 'memory'),
    descriptor('proposal.create', 'config.draft', 'governance'), descriptor('quorum', 'human.question.create', 'governance'),
    descriptor('epic.update', 'task.triage', 'epics'), descriptor('epic.question', 'task.triage', 'epics'),
    descriptor('epic.question.update', 'task.triage', 'epics'), descriptor('epic.prototype', 'task.triage', 'epics'),
    descriptor('epic.feedback', 'task.triage', 'epics'),
    descriptor('run.list', 'run.read', 'runs'), descriptor('run.cancel', 'run.cancel', 'runs'),
    descriptor('release.list_targets', 'deploy.execute', 'releases'),
    descriptor('release.prepare_plan', 'deploy.execute', 'releases'),
    descriptor('release.create_operation', 'deploy.execute', 'releases'),
    descriptor('release.start_attempt', 'deploy.execute', 'releases'),
    descriptor('release.report_attempt', 'deploy.execute', 'releases'),
    descriptor('release.resolve_plan', 'deploy.execute', 'releases'),
    descriptor('release.status', 'deploy.execute', 'releases'),
];
export function platformToolDescriptor(id) {
    return PLATFORM_TOOL_CATALOG.find((tool) => tool.id === id) ?? null;
}
//# sourceMappingURL=tools.js.map